import * as $ from "jquery";
import * as Popper from "popper.js";
import "bootstrap";
import svg4everybody from "svg4everybody";

window.$ = $;
window.jQuery = $;
window.Popper = Popper;

svg4everybody();

$(function() {
  "use strict";

  $('[data-toggle="offcanvas"]').on("click", function() {
    $("#sidebar").toggleClass("open");
  });

  $('[data-toggle="popover"]').popover();
  $('[data-toggle="tooltip"]').tooltip();
});
